import { useTranslation } from 'react-i18next'

const NotFoundPage = () => {
  const { t } = useTranslation('common')
  return (
    <div>
      <h1>404 Not Found</h1>
      <p>{t('not_found_page')}</p>
    </div>
  )
}

export default NotFoundPage
